import {
  EventTypes,
  PageSource,
  TRACK_CONTENT_TYPES,
  track,
} from '@mc/track-event'

interface EpisodePageEventProps {
  episodeSlug: string
  seriesSlug: string
}

interface EpisodeGemClickProps {
  contentId: string
  contentTitle: string
}

interface EpisodeToggleShowAllProps {
  copy: string
}

export const trackEpisodeGemClick = ({
  episodeSlug,
  seriesSlug,
  contentId,
  contentTitle,
}: EpisodePageEventProps & EpisodeGemClickProps) => {
  track(EventTypes.EPISODE_PAGE_CLICK, {
    episode: episodeSlug,
    class: seriesSlug,
    category: 'media-playback',
    location: 'episodes',
    action: TRACK_CONTENT_TYPES.EPISODE_GEM,
    page_path: window.location.pathname,
    page_source: PageSource.EPISODE_PAGE,
    content_id: contentId,
    content_title: contentTitle,
  })
}

export const trackToggleShowAll = ({
  episodeSlug,
  seriesSlug,
  copy,
}: EpisodePageEventProps & EpisodeToggleShowAllProps) => {
  track(EventTypes.EPISODE_PAGE_CLICK, {
    episode: episodeSlug,
    class: seriesSlug,
    action: copy,
    location: 'episodes',
    page_path: window.location.pathname,
    page_source: PageSource.EPISODE_PAGE,
  })
}

export const trackEpisodeClick = ({
  seriesSlug,
  episodeSlug,
}: EpisodePageEventProps) => {
  track(EventTypes.EPISODE_PAGE_CLICK, {
    class: seriesSlug,
    episode: episodeSlug,
    location: 'episodes',
    action: 'Episode',
  })
}
